import { useEffect, useState } from "react";
import Icon from "../../lib/icons";
import { useLang } from "../../i18n";
import { api, resolveMedia } from "../../lib/api";
import { IMPACT_CARDS } from "../../data/content";
import { Reveal, SectionHeading } from "../Reveal";

const ICON_TO_CATEGORY = {
  BookOpen: "education", Stethoscope: "health", HandHeart: "women",
  TreePine: "environment", HeartHandshake: "community", Megaphone: "awareness",
};

export default function Impact() {
  const { t, pick } = useLang();
  const [photos, setPhotos] = useState({});

  useEffect(() => {
    api.get("/gallery").then((res) => {
      const map = {};
      for (const it of res.data.items || []) {
        if (!map[it.category] && it.url) map[it.category] = it;
      }
      setPhotos(map);
    }).catch(() => {});
  }, []);

  return (
    <section data-testid="impact-section" className="py-24 bg-ngo-cream relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <SectionHeading
          overline={t("nav.impact")}
          title={pick({ hi: "हम जिन क्षेत्रों में बदलाव ला रहे हैं", en: "Areas where we are creating change" })}
          description={pick({
            hi: "जमीनी स्तर पर समुदाय के साथ मिलकर — सहायता से आत्मनिर्भरता तक की यात्रा।",
            en: "Working with communities at the grassroots — from support to self-reliance.",
          })}
          testid="impact-heading"
        />
        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {IMPACT_CARDS.map((card, i) => {
            const photo = photos[ICON_TO_CATEGORY[card.icon]];
            return (
            <Reveal key={card.icon + i} i={i}>
              <div
                data-testid={`impact-card-${i}`}
                className="group h-full bg-white rounded-2xl border border-ngo-deep/10 overflow-hidden shadow-[0_8px_30px_rgba(23,107,58,0.06)] hover:shadow-[0_18px_44px_rgba(23,107,58,0.14)] hover:-translate-y-1.5 transition-[box-shadow,transform] duration-300"
              >
                {photo && (
                  <div className="h-40 overflow-hidden">
                    <img src={resolveMedia(photo.url)} alt={photo.caption_hi} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                  </div>
                )}
                <div className="p-7">
                  <div className="w-[52px] h-[52px] rounded-2xl bg-ngo-mint flex items-center justify-center text-ngo-deep group-hover:bg-ngo-deep group-hover:text-ngo-gold transition-colors duration-300">
                    <Icon name={card.icon} size={24} />
                  </div>
                  <h3 className="mt-5 font-heading font-bold text-xl text-ngo-ink">{pick({ hi: card.hi.title, en: card.en.title })}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-ngo-ink/65">{pick({ hi: card.hi.desc, en: card.en.desc })}</p>
                </div>
              </div>
            </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
